import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-tecno-cup',
  templateUrl: './tecno-cup.component.html',
  styleUrls: ['./tecno-cup.component.scss']
})
export class TecnoCupComponent implements OnInit {
  loading = false
  constructor(public globalService:GlobalService , private titleService: Title) {
    this.titleService.setTitle('tecno-pubg-mobile-cup')

  }


  ngOnInit(): void {

    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.globalService.customLang = require('./lang/' + localStorage.getItem('language') + '.json');
        this.globalService.langChosen = localStorage.getItem('language');
      } else {
        localStorage.setItem('language' , 'ar')
        this.globalService.customLang = localStorage.getItem('language')
      }
    }

  }
  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.globalService.langChosen = value;
      this.globalService.customLang = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);

    }
  }
}
